import { FailedToGetData, H2, Loading, RadioSelector } from '../_commons';
import { generalHelpers, months } from '@monorepo/helpers';
import { houseToHouseServices, hthHelper } from 'src/services';
import { HTHFeedbackTerritory } from './subcomponents/HTHFeedbackTerritory';
import { setAlertResponse } from 'src/store';
import { typeConfigDoc, typeHTHTerritory } from '@monorepo/models';
import { useDispatch } from 'react-redux';
import { useEffect, useMemo, useState } from 'react';
import { useGetConfig, useGetIsDarkMode } from 'src/custom-hooks';
import { useParams } from 'react-router-dom';

{/* http://localhost:3000/actividad/1/1753475108282/1754164447000?ulfb=true */}

export const HthFeedbackPage = () => {
    const congregationParam = parseInt(useParams().congregation ?? '0') as number;
    const datetime = parseInt(useParams().datetime || '0');
    const serviceId = parseInt(useParams().serviceId || '0');
    //
    const [congregationConfig, setCongregationConfig] = useState<typeConfigDoc | null>(null);
    const [hthTerritories, setHthTerritories] = useState<typeHTHTerritory[] | null>(null);
    const [isLoading, setIsLoading] = useState(true);
    const [radioValue, setRadioValue] = useState('');
    const config = useGetConfig();
    const dateString = generalHelpers.FormatDate(new Date(datetime));
    const dateStringFormatted = `${parseInt(dateString.split('-')[2])} de ${months[parseInt(dateString.split('-')[1]) - 1]} de ${dateString.split('-')[0]}`;
    const dispatch = useDispatch();
    const isDarkMode = useGetIsDarkMode();

    const congregation = useMemo(() =>
        config.congregation || congregationParam || null
    , [config]);

    if (!congregation || !datetime || !serviceId) {
        return <FailedToGetData />;
    }

    // const saveHandler = () => {
    //     if (!hthTerritories) {
    //         return;
    //     }
    //     dispatch(setValuesAndOpenAlertModalReducer({
    //         title: 'Confirmar',
    //         message: `Se van a guardar los cambios para la salida del ${dateString}, ${territoryNumbers.length > 1 ? `territorios ${territoryNumbers.join(', ')}` : `territorio ${territoryNumbers.join('')}`}`,
    //         mode: 'confirm',
    //         execution: async () => {
    //             dispatch(showLoadingModalReducer());
    //             const success = await houseToHouseServices.SetActivityFeedback(congregation, datetime, hthTerritories);
    //             dispatch(hideLoadingModalReducer());
    //             if (!success) {
    //                 dispatch(setValuesAndOpenAlertModalReducer({
    //                     title: 'Algo falló',
    //                     message: 'No se pudo guardar; ver si hay internet',
    //                     animation: 2,
    //                     mode: 'alert'
    //                 }));
    //                 return;
    //             }
    //             dispatch(setValuesAndOpenAlertModalReducer({
    //                 title: 'Logrado',
    //                 message: '¡Muchas gracias! Esta información es muy útil para la gestión del servicio del campo',
    //                 animation: 1,
    //                 mode: 'alert'
    //             }));
    //             navigate('/');
    //         }
    //     }));
    // }

    useEffect(() => {
        houseToHouseServices.GetTerritoriesFromServiceUnauth(congregation, serviceId).then(response => {
            setIsLoading(false);
            if (!response.success || !response.data?.config || !response.data?.hthTerritories) {
                dispatch(setAlertResponse({ response }));
                return;
            }
            const x = hthHelper.SetIsCoveredAndColorForHTHPolygons(response.data.hthTerritories, serviceId, datetime);
            setHthTerritories(x);
            setCongregationConfig(response.data.config);
        });
        return () => {
            houseToHouseServices.SetActivityFeedback(congregation, datetime, [], serviceId, true);
        };
    }, []);

    if (isLoading) {
        return <Loading mt={'80px'} />;
    }

    if (!congregationConfig || !hthTerritories) {
        return <FailedToGetData />;
    }

    return (
        <div className={isDarkMode ? 'text-white' : ''}>
            <H2 title={`TERRITORIO ABARCADO EL`}
                mb={'12px'}
            />
            <H2 title={dateStringFormatted.toUpperCase()}
                mt={'0'}
            />
            <RadioSelector
                options={hthTerritories.map(t => ({
                    label: t.territoryNumber === radioValue ? `Viendo Territorio ${t.number}` : `Ver Territorio ${t.number}`,
                    type: String(t.territoryNumber)
                }))}
                radioValue={radioValue}
                setRadioValue={setRadioValue}
            />
            {radioValue ?
                <div className={`${isDarkMode ? 'text-white' : ''} mb-5`}>
                    <HTHFeedbackTerritory
                        congregation={congregationConfig.congregation}
                        datetime={datetime}
                        hthTerritories={hthTerritories}
                        hthTerritory={hthTerritories.find(t => t.territoryNumber === radioValue)!}
                        serviceId={serviceId}
                        setHthTerritories={setHthTerritories}
                        usingLettersForBlocks={!!congregationConfig.isUsingLettersForBlocks}
                    />
                </div>
                :
                <div className={`card ${isDarkMode ? 'bg-lightdark text-white border-light' : ''} text-center p-3 mt-5`}>
                    <div className={'mb-2'}>
                        Por favor, señalar en {hthTerritories.length > 1 ? 'los mapas' : 'el mapa'} o en los marcadores que están debajo las manzanas o caras que se cubrieron durante la predicación del {dateStringFormatted}.
                    </div>
                    <div className={'mb-2'}>
                        Este trabajo extra de los capitanes de las salidas es de una gran utilidad para la óptima gestión de los territorios asignados a la congregación.
                    </div>
                    <div className={'mb-3'}>
                        ¡Muchísimas gracias!
                    </div>
                    <div className={'mb-2'}>
                        *Nota 1: Los cambios quedan guardados automáticamente así que se puede cerrar esta página después de haber marcado lo trabajado.
                    </div>
                    <div>
                        *Nota 2: Esta página solamente puede ser usada para la predicación del día {dateStringFormatted}.
                    </div>
                </div>
            }
            {/* <div className={`${isDarkMode ? 'text-white' : ''} mb-5`}>
                {hthTerritories.map(t =>
                    <HTHFeedbackTerritory key={t.territoryNumber}
                        hthTerritory={t}
                        setHthTerritories={setHthTerritories}
                        usingLettersForBlocks={!!congregationConfig.usingLettersForBlocks}
                    />
                )}
            </div> */}
            {/* <Hr /> */}
            {/* <div className={'d-flex justify-content-center my-3'}>
                <div>
                    <button
                        className={'btn btn-general-blue w-100 fw-bolder mt-4'}
                        style={{ height: '50px' }}
                        onClick={saveHandler}
                    >
                        ACEPTAR CAMBIOS
                    </button>
                </div>
            </div> */}
        </div>
    );
}
